    package it.neckar.open.version

    /**
     * Contains stable version constants that rarely change.
     * Git info is resolved at runtime from the injected deploy metadata (see VersionInformation).
     */
    object VersionConstants {
      val monorepoVersion: String = "10.2.0-SNAPSHOT"
    }

    /**
     * The git properties resolvable at runtime, with their injection coordinates.
     * Generated 1:1 from the GitProperty enum in build-logic ResourcesExt.kt (single source of
     * truth), so injection (image env, fat-jar resource, serve-time HTML) and resolution
     * cannot drift.
     */
    enum class GitProperty(
      /**
       * Key in the fat-jar app-git-info.properties resource and in window.__APP_GIT_INFO__.
       */
      val propertyKey: String,
      /**
       * Environment variable baked into service images at image build.
       */
      val envVar: String,
      /**
       * JVM system property that overrides the environment variable (highest priority).
       */
      val systemProperty: String,
    ) {
      Hash("gitHash", "APP_GIT_HASH", "app.git.hash"),
CommitDateTime("gitCommitDateTime", "APP_GIT_COMMIT_DATETIME", "app.git.commitDateTime"),
    }
